import { render } from "./Project-2.vue?vue&type=template&id=bbcb059a"
import script from "./Project-2.vue?vue&type=script&lang=js"
export * from "./Project-2.vue?vue&type=script&lang=js"
script.render = render

export default script